import React from 'react';
import Accordion from 'react-bootstrap/Accordion';
import Card from 'react-bootstrap/Card';
import NavigationItem from '../NavigationItem/NavigationItem'
import NavigationLink from '../NavigationLink/NavigationLink'
import classes from './NavigationAccordion.css'

function renderNavItem(index, path, selected, element, itemPath, props) {
  return (
    <NavigationItem
      key={element['name'] + index}
      name={element['name']}
      src={element['src']}
      selected={selected}
      setContentPath={props.setContentPath}
      itemPath={itemPath + '/' + element['name'].replace(/\s+/g, '')}
      itemIndex={path}
      setAccordionKeys={props.setAccordionKeys}
    />
  );
};

function renderNavLink(index, path, element, props) {
  return (
    <NavigationLink
      key={element['name'] + index}
      name={element['name']}
      src={element['src']}
      itemIndex={path}
      setAccordionKeys={props.setAccordionKeys}
    />
  );
};

const navigationAccordion = (props) => {

  let makeAccordion = (name, items, selectedItems, itemIndex, itemPath, accordionKeys) => {
    let navElements = items.map(
      (element,i) => {
        let navitemIndex = itemIndex.concat(i);
        if (element['type'] === 'navItem') {
          let selected = (selectedItems.toString()).indexOf(navitemIndex.toString()) === 0
          return renderNavItem(i, navitemIndex, selected, element, itemPath, props);
        }
         else if (element['type'] === 'navLink') {
           return renderNavLink(i, navitemIndex, element, props);
         }
         else if (element['type'] === 'navAccordion') {
           return (
             <Accordion activeKey={accordionKeys[0]}>
               {makeAccordion(element['name'], element['items'], selectedItems, itemIndex.concat(i), itemPath + "/" + element['name'], [...accordionKeys].splice(1))}
             </Accordion>
           )
         }
        return undefined;
      }
    ).filter(Boolean);

    let index = itemIndex[itemIndex.length - 1]
    let selected = (selectedItems.toString()).indexOf(itemIndex.toString()) === 0
    let cardClasses = (selected ? 'selected ' : '');

    return (
      <Card >
        <Accordion.Toggle as={Card.Header} className={cardClasses} style={{ padding: '1.25rem'}} eventKey={index}
          onMouseEnter={() => props.setAccordionKeys(itemIndex)}
          onClick={() => props.setAccordionKeys(itemIndex)}>
          <p>{name}</p>
        </Accordion.Toggle>
        <Accordion.Collapse eventKey={index}>
          <Card.Body>{navElements}</Card.Body>
        </Accordion.Collapse>
      </Card>
    )
  }

  return (
    <div className='acordion-list'>
      {makeAccordion(props.name, props.items, props.selectedItems, props.itemIndex, props.itemPath, props.accordionKeys)}
    </div>
  )
};

export default navigationAccordion
